import { Search } from "@mui/icons-material";
import { TextField, InputAdornment } from "@mui/material";
import { useState, useEffect, useRef } from "react";

import { useDebounce } from "../../../../hooks/useDebounce";
import { useQueryParams } from "../../../../hooks/useQueryParams";
import HNSColors from "../../../ui library/HNSColors";
import { SEARCH_PLACEHOLDER, DEBOUNCE_DELAY } from "../utils/strings";

export default function SearchBar() {
  const { filters, updateFilter } = useQueryParams();
  const initialVal = filters.get("search") || "";
  const [searchVal, setSearchVal] = useState(initialVal);
  const debouncedSearch = useDebounce(searchVal, DEBOUNCE_DELAY);
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    updateFilter("search", debouncedSearch || null);
  }, [debouncedSearch]);

  useEffect(() => {
    if (!initialVal) {
      setSearchVal("");
    }
  }, [initialVal]);

  return (
    <TextField
      className="w-full rounded-lg text-sm placeholder:text-center"
      placeholder={SEARCH_PLACEHOLDER}
      size="small"
      name="document-search"
      value={searchVal}
      onChange={(event) => {
        setSearchVal(event.target.value);
      }}
      variant="outlined"
      style={{ width: "28rem" }}
      sx={{
        backgroundColor: HNSColors.neutrals[900],
        borderRadius: "999px",
        "& .MuiOutlinedInput-root": {
          padding: "2px 16px 2px 16px",
          borderRadius: "999px",
          "& fieldset": {
            borderColor: HNSColors.primary[900],
          },
          "&:hover fieldset": {
            borderColor: HNSColors.primary[400],
          },
        },
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search color="action" />
          </InputAdornment>
        ),
      }}
    />
  );
}
